import useProfile from "api/UserResource/useProfile";
import ChangeEmailAddress from "./ChangeEmailAddress";
import AccountPage from "../AccountPage";
import AccountLayout from "../AccountLayout";

const Emails = () => {
	const { data: profile, isLoading } = useProfile();
	return (
		<AccountPage>
			<AccountLayout isLoading={isLoading} profile={profile?.data}>
				<ChangeEmailAddress />
			</AccountLayout>
		</AccountPage>
	);
};
export default Emails;
